module.exports = __webpack_public_path__ + "static/media/lend_btc.3a3ed532.svg";